"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Admin1 = function Admin1(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 26 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 26 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Admin1' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Admin1' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 26 26"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "path-1",
    points: "0 0.000136363636 22 0.000136363636 22 15.0001364 0 15.0001364"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Britive-Admin_Tenant-",
    transform: "translate(-21.000000, -121.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "1",
    transform: "translate(22.000000, 122.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.8536585,21.5121951 C23.8536585,22.8052683 22.8052683,23.8536585 21.5121951,23.8536585 L2.48780488,23.8536585 C1.19473171,23.8536585 0.146341463,22.8052683 0.146341463,21.5121951 L0.146341463,2.48780488 C0.146341463,1.19473171 1.19473171,0.146341463 2.48780488,0.146341463 L21.5121951,0.146341463 C22.8052683,0.146341463 23.8536585,1.19473171 23.8536585,2.48780488 L23.8536585,21.5121951 Z",
    id: "Shape",
    stroke: color,
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval",
    fill: color,
    fillRule: "nonzero",
    cx: "15.2926829",
    cy: "2.48780488",
    r: "1"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval",
    fill: color,
    fillRule: "nonzero",
    cx: "18.2195122",
    cy: "2.48780488",
    r: "1"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval",
    fill: color,
    fillRule: "nonzero",
    cx: "21.1463415",
    cy: "2.48780488",
    r: "1"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: "6.07843902",
    cy: "16.1411707",
    r: "1.13004878"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval",
    stroke: color,
    cx: "13.8377561",
    cy: "16.1411707",
    r: "1.13004878"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval",
    stroke: color,
    cx: "10.1622439",
    cy: "12.0573659",
    r: "1.13004878"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: "17.921561",
    cy: "12.0573659",
    r: "1.13004878"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.93307317,15.4085854 L9.32868293,13.0123902",
    id: "Shape",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.6918049,15.4085854 L17.0882927,13.0123902",
    id: "Shape",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.0627317,15.0585366 L10.9653659,12.9614634",
    id: "Shape",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.5,5.5 L23.5,5.5",
    id: "Line-2",
    stroke: color,
    strokeLinecap: "square"
  })))));
};
Admin1.propTypes = _index.iconProps;
var _default = Admin1;
exports["default"] = _default;